import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../badRequestHandler/BadRequestHandler";

export const Instagram = createApi({
  reducerPath: "instagram",
  baseQuery: dynamicBaseQuery,
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    instagramInstructionData: builder.query({
      query: ({ category }) => {
        return {
          url: `v1/common/instructions/?category=${category}`,
          method: "GET",
        };
      },
    }),

    instagramInstruction: builder.mutation({
      query: ({ body }) => {
        return {
          url: `v1/common/instructions/`,
          method: "POST",
          body,
        };
      },
    }),
    updateInstagramInstruction: builder.mutation({
      query: ({ body,id }) => {
        return {
          url: `v1/common/instructions/${id}/`,
          method: "PUT",
          body,
        };
      },
    }),


    getYoutubeConfiguration: builder.query({
      query: () => {
        return {
          url: `v1/socialmedia/youtube-config/`,
          method: "GET",
        };
      },
    }),
    getVectorConfiguration: builder.query({
      query: () => {
        return {
          url: `v1/socialmedia/vector-config/`,
          method: "GET",
        };
      },
    }),

    getAiConfiguration: builder.query({
      query: () => {
        return {
          url: `v1/socialmedia/ai-config/`,
          method: "GET",
        };
      },
    }),

    createYoutubeConfiguration: builder.mutation({
      query: ({ body }) => {
        return {
          url: `v1/socialmedia/youtube-config/`,
          method: "POST",
          body,
        };
      },
    }),
    createYoutubeConfigurationVector: builder.mutation({
      query: ({ body }) => {
        return {
          url: `v1/socialmedia/vector-config/`,
          method: "POST",
          body,
        };
      },
    }),
    createYoutubeConfigurationAi: builder.mutation({
      query: ({ body }) => {
        return {
          url: `v1/socialmedia/ai-config/`,
          method: "POST",
          body,
        };
      },
    }),
    useUpdateYoutubeConfigurationMutation: builder.mutation({
      query: ({ body, id }) => {
        return {
          url: `v1/socialmedia/youtube-config/${id}/`,
          method: "PATCH",
          body,
        };
      },
    }),

    useUpdateYoutubeConfigurationVectorMutation: builder.mutation({
      query: ({ body, id }) => {
        return {
          url: `v1/socialmedia/vector-config/${id}/`,
          method: "PATCH",
          body,
        };
      },
    }),

    useUpdateYoutubeConfigurationAiMutation: builder.mutation({
      query: ({ body, id }) => {
        return {
          url: `v1/socialmedia/ai-config/${id}/`,
          method: "PATCH",
          body,
        };
      },
    }),

    getYoutubeVideos: builder.query({
      query: ({ teamId, channelId }) => {
        return {
          url: `v1/socialmedia/youtube-videos/?team_id=${teamId}&channel_id=${channelId}`,
          method: "GET",
        };
      },
    }),
    getYouTubeVideoComments: builder.query({
      query: ({ teamId, channelId, videoId }) => {
        return {
          url: `v1/socialmedia/youtube-comments/?team_id=${teamId}&channel_id=${channelId}&video_id=${videoId}`,
          method: "GET",
        };
      },
    }),

    deleteYoutubeConfiguration: builder.mutation({
      query: ({ id }) => {
        return {
          url: `v1/socialmedia/youtube-config/${id}/`,
          method: "DELETE",
        };
      },
    }),


    deleteVectorConfiguration: builder.mutation({
      query: ({ id }) => {
        return {
          url: `v1/socialmedia/vector-config/${id}/`,
          method: "DELETE",
        };
      },
    }),
    deleteAiConfiguration: builder.mutation({
      query: ({ id }) => {
        return {
          url: `v1/socialmedia/ai-config/${id}/`,
          method: "DELETE",
        };
      },
    }),

    getSocialListening: builder.query({
      query: ({ socialListening }) => {
        return {
          url: `v1/socialmedia/${socialListening}/social-listening/`,
          method: "GET",
        };
      },
    }),
    getSocialListeningTags: builder.query({
      query: ({ socialListening }) => {
        return {
          url: socialListening === 'instagram'
            ? `v1/socialmedia/tags/`
            : `v1/socialmedia/${socialListening}/tags/`,
          method: "GET",
        };
      },
    }),
    updateSocialListeningTags: builder.mutation({
      query: ({ body, socialListening }) => {
        return {
          url: socialListening === 'instagram'
            ? `v1/socialmedia/tags/`
            : `v1/socialmedia/${socialListening}/tags/`,
          method: "PUT",
          body,
        };
      },
    }),


    createInstagramPost: builder.mutation({
      query: ({ body }) => {
        return {
          url: `v1/socialmedia/instagram/post/`,
          method: "POST",
          body,
        };
      },
    }),
    getInstagramPost: builder.query({
      query: () => {
        return {
          url: `v1/socialmedia/instagram/get-posts/`,
          method: "GET",
        };
      },
    }),






  }),
});
export const {
  useInstagramInstructionDataQuery,
  useInstagramInstructionMutation,
  useCreateYoutubeConfigurationMutation,
  useCreateYoutubeConfigurationVectorMutation,
  useCreateYoutubeConfigurationAiMutation,
  useUseUpdateYoutubeConfigurationAiMutationMutation,
  useUseUpdateYoutubeConfigurationMutationMutation,
  useUseUpdateYoutubeConfigurationVectorMutationMutation,
  useGetAiConfigurationQuery,
  useGetVectorConfigurationQuery,
  useGetYoutubeConfigurationQuery,
  useGetYoutubeVideosQuery,
  useGetYouTubeVideoCommentsQuery,
  useDeleteYoutubeConfigurationMutation,
  useDeleteVectorConfigurationMutation,
  useDeleteAiConfigurationMutation,
  useUpdateInstagramInstructionMutation,
  useGetSocialListeningQuery,
  useGetSocialListeningTagsQuery,
  useUpdateSocialListeningTagsMutation,
  useCreateInstagramPostMutation,
  useGetInstagramPostQuery
} = Instagram;